<nav aria-label="Date navigation control" class="px-8 py-6 gap-4 flex text-gray-500 items-center">

  <ul class="flex gap-4">
    <li class="leading-0">
      <app-button2 aria-label="Refresh"
        appearance="secondary"
        size="s"
        (click)="refresh.emit()">
        <app-icon name="refresh"/>
      </app-button2>
    </li>
    <li class="leading-0">
      <app-button2 aria-label="Previous period"
        appearance="secondary"
        size="s"
        [disabled]="loading()"
        (click)="prevDate()">
        <app-icon name="chevron-left"/>
      </app-button2>
    </li>
    <li class="leading-0">
      <app-button2 aria-label="Next period"
        appearance="secondary"
        size="s"
        [disabled]="loading()"
        (click)="nextDate()">
        <app-icon name="chevron-right"/>
      </app-button2>
    </li>
  </ul>

  <span class="grow"></span>

  <span class="text-sm text-nowrap overflow-hidden text-ellipsis text-subdued">
    {{dateRangeText()}}
  </span>
</nav>
